module.exports = Backbone.Collection.extend({
  comparator: 'distance'
});



// WEBPACK FOOTER //
// ./epayment_import/collections/contact.js